var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSyncAlt = function SvgSyncAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m768 512-60.16-60.16L775.253 384H128v-85.333h647.253l-67.413-67.84 60.16-60.16 170.667 170.667L768 512.001zm-512 0 60.16 60.16L248.747 640H896v85.333H248.747l67.413 67.84-60.16 60.16L85.333 682.666 256 511.999z"
  })));
};
export default SvgSyncAlt;